import { Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";

import PrivateRoute from "./common/routing/privateRoute";
import PublicRoute from "./common/routing/publicRoute";

import { LoadingBarTop } from "./common/components/loading";
import { useUser } from "./common/hooks/User";
import { getUserProfile } from "./common/apis/private.api";
import { getLocalData, _tokenName } from "./common/helpers/localData";

// private components
import { Home } from './pages/home';
import { Profile } from './pages/profile';
import { ProfileEdit } from "./pages/profile/edit";
import { Favorites } from "./pages/favorites";
import { Help } from "./pages/help";
import { MyProcess } from "./pages/my_process";
import { Apply } from "./pages/apply";
import { Overview } from "./pages/apply/overview";

// public components
import { Login } from './pages/login';
import { NotFound } from './pages/not_found';
import { Register } from "./pages/register";
import { ForgotPassword } from "./pages/forgot_password";
import { Opportunity } from "./pages/opportunity";
import { SuccessSubscription } from "./pages/success";
import VerifySubscription from "./pages/apply/verify-subscription";

type TStatus = "loading" | "done";

export const Routers = () => {
  const [status, setStatus] = useState<TStatus>("loading");
  const { initUserSession } = useUser();
  const authData = getLocalData(_tokenName);

  useEffect(() => {
    if (authData) {
      Auth.currentAuthenticatedUser().then(async (auth) => {
        getUserProfile(auth.attributes.email).then((profile) => {

          initUserSession(auth, profile);
          setStatus("done");

        }).catch(() => {

          initUserSession(auth);
          setStatus("done");
        });
        // this is so we hide the loading page
      }).catch(() => { setStatus("done") });
    } else { setStatus("done") }
    // eslint-disable-next-line
  }, []);

  if (status === "loading") {
    return <LoadingBarTop />;
  }

  return (
    <Routes>
      {/* AUTH ROUTES */}
      <Route path={'/login'} element={<Login />} />
      <Route path={'/register'} element={<Register />} />
      <Route path={'/forgot-password'} element={<ForgotPassword />} />

      {/* PUBLIC ROUTES */}
      <Route path={'/opportunity/:oid/:cid'} element={
        <PublicRoute>
          <Opportunity />
        </PublicRoute>
      } />
      <Route path={'/success-subscription'} element={
        <PublicRoute>
          <SuccessSubscription />
        </PublicRoute>
      } />

      {/* PRIVATE ROUTES */}
      <Route path={'/'} element={
        <PrivateRoute>
          <Home />
        </PrivateRoute>
      } />
      <Route path={'/apply/:oid/:cid'} element={
        <PrivateRoute showBackBtnTop>
          <Apply />
        </PrivateRoute>
      } />
      <Route path={'/apply/verify-subscription/:status'} element={
        <PrivateRoute>
          <VerifySubscription />
        </PrivateRoute>
      } />
      <Route path={'/overview/:oid/:cid'} element={
        <PrivateRoute>
          <Overview />
        </PrivateRoute>
      } />
      <Route path={'/profile'} element={
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      } />
      <Route path={'/profile-edit'} element={
        <PrivateRoute showBackBtnTop>
          <ProfileEdit />
        </PrivateRoute>
      } />
      <Route path={'/favorites'} element={
        <PrivateRoute showBackBtnTop>
          <Favorites />
        </PrivateRoute>
      } />
      <Route path={'/my-process'} element={
        <PrivateRoute>
          <MyProcess />
        </PrivateRoute>
      } />
      <Route path={'/help'} element={
        <PrivateRoute>
          <Help />
        </PrivateRoute>
      } />

      {/* ROUTES NO FOUND */}
      <Route path={'*'} element={
        <PrivateRoute hideSideMenu>
          <NotFound />
        </PrivateRoute>
      } />
    </Routes>
  )
}